import React from "react";
import { Autoplay, Parallax } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import KidexContainer from "./KidexContainer";
import schWrkCrd1 from "../../../Assets/landing-page/sch-wrk-1.svg";
import schWrkCrd2 from "../../../Assets/landing-page/sch-wrk-2.svg";
import schWrkCrd3 from "../../../Assets/landing-page/sch-wrk-3.svg";
import schWrkCrd4 from "../../../Assets/landing-page/sch-wrk-4.svg";
import schWrkCrd5 from "../../../Assets/landing-page/sch-wrk-5.svg";
import schWrkCrd6 from "../../../Assets/landing-page/sch-wrk-6.svg";
import schWrkCrd7 from "../../../Assets/landing-page/sch-wrk-7.svg";
import schWrkCrd8 from "../../../Assets/landing-page/sch-wrk-18.png";
import schWrkCrd9 from "../../../Assets/landing-page/sch-wrk-9.svg";
import schWrkCrd10 from "../../../Assets/landing-page/sch-wrk-10.svg";
import schWrkCrd11 from "../../../Assets/landing-page/sch-wrk-11.svg";
import schWrkCrd12 from "../../../Assets/landing-page/sch-wrk-12.svg";
import schWrkCrd13 from "../../../Assets/landing-page/sch-wrk-13.svg";
import schWrkCrd14 from "../../../Assets/landing-page/sch-wrk-14.svg";
import schWrkCrd15 from "../../../Assets/landing-page/sch-wrk-15.svg";
import schWrkCrd16 from "../../../Assets/landing-page/sch-wrk-16.svg";
import schWrkCrd17 from "../../../Assets/landing-page/sch-wrk-17.svg";
import "swiper/swiper.min.css";

const SchoolList = () => {
   return (
      <React.Fragment>
         <section className="school-crousel-sec">
            <div className="sec-main-heading outer-space">
               Select list of schools we work with
            </div>
            <KidexContainer>
               <div className="school-crousel swiper_wrap">
                  <Swiper
                     modules={[Autoplay, Parallax]}
                     spaceBetween={0}
                     speed={6000}
                     autoplay={{ delay: 1, disableOnInteraction: false, reverseDirection: false, waitForTransition: true }}
                     loop={true}
                     watchSlidesProgress={true}
                     grabCursor={true}
                     breakpoints={{
                        320: {
                           spaceBetween: 8,
                           slidesPerView: 1,
                        },
                        460: {
                           spaceBetween: 10,
                           slidesPerView: 1.2,
                        },
                        480: {
                           spaceBetween: 10,
                           slidesPerView: 1.2,
                        },
                        576: {
                           spaceBetween: 10,
                           slidesPerView: 2.2,
                        },
                        768: {
                           spaceBetween: 8,
                           slidesPerView: 2.5,
                        },
                        820: {
                           spaceBetween: 8,
                           slidesPerView: 3.5,
                        },
                        960: {
                           spaceBetween: 8,
                           slidesPerView: 3.5,
                        },
                     }}
                  >
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd1} />
                           </div>
                           <p className="sch-crosl-title">
                              Lakshmipat Singhania Academy
                           </p>
                           <span>Kolkata</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd2} />
                           </div>
                           <p className="sch-crosl-title">Sneh International School</p>
                           <span>New Delhi</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd3} />
                           </div>
                           <p className="sch-crosl-title">Uttam School of Girls</p>
                           <span>Ghaziabad</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd4} style={{ width: "75%" }} />
                           </div>
                           <p className="sch-crosl-title">Army Public School, Meerut</p>
                           <span>Meerut</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd5} />
                           </div>
                           <p className="sch-crosl-title">DAV Model School</p>
                           <span>IIT Kharagpur</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd6} />
                           </div>
                           <p className="sch-crosl-title">Delhi Public School </p>
                           <span>Alwar</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd7} />
                           </div>
                           <p className="sch-crosl-title">
                              Bhawarilal Samra English High School{" "}
                           </p>
                           <span>Amravati</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd17} />
                           </div>
                           <p className="sch-crosl-title">
                              Narayandas Laddha High School{" "}
                           </p>
                           <span>Amravati</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd8} />
                           </div>
                           <p className="sch-crosl-title">
                              Kanchi Sri Sankara Academy Matriculation Higher Secondary
                              School{" "}
                           </p>
                           <span>Tuticorin</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd9} />
                           </div>
                           <p className="sch-crosl-title">
                              Mata Sahib Kaur Public School{" "}
                           </p>
                           <span>Guruharsahai</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd10} />
                           </div>
                           <p className="sch-crosl-title">
                              Spic Nagar Higher Secondary School{" "}
                           </p>
                           <span>Tuticorin</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd11} />
                           </div>
                           <p className="sch-crosl-title">Lord Krishna Public School </p>
                           <span>Mahendragarh</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd12} />
                           </div>
                           <p className="sch-crosl-title">Satluj Public School </p>
                           <span>Ellenabad</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd13} />
                           </div>
                           <p className="sch-crosl-title">Vikas Bharti Public School</p>
                           <span>New Delhi</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd14} />
                           </div>
                           <p className="sch-crosl-title">
                              Divyakulam Public School Kurana,{" "}
                           </p>
                           <span>Panipat</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd17} />
                           </div>
                           <p className="sch-crosl-title">
                              Government Senior Secondary School{" "}
                           </p>
                           <span>Nagwain</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd15} />
                           </div>
                           <p className="sch-crosl-title">Aryaman Public School</p>
                           <span>Najafgarh, New Delhi</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd17} />
                           </div>
                           <p className="sch-crosl-title">
                              Shiksha Academy Sr. Sec. Public School{" "}
                           </p>
                           <span>Ghumarwin, Bilaspur</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd17} />
                           </div>
                           <p className="sch-crosl-title">H D Public School</p>
                           <span>Bahuakbarpur, Rohtak</span>
                        </div>
                     </SwiperSlide>
                     <SwiperSlide className="sch-crd-outer">
                        <div className="sch-crosl-card">
                           <div className="sch-crosl-card-img">
                              <img src={schWrkCrd16} />
                           </div>
                           <p className="sch-crosl-title">Gyan Bharti Public School</p>
                           <span> Ardana, Karnal</span>
                        </div>
                     </SwiperSlide>
                  </Swiper>
               </div>
            </KidexContainer>
         </section>
      </React.Fragment>
   );
};

export default SchoolList;
